export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const AUTH_VERIFY = '/auth/verify';
export const AUTH_RESET_PASSWORD = '/auth/reset-password';
export const ADMIN = '/admin';
// export const ADMIN_DETAILS = '/admin/:id';
export const CALCULATOR = '/Calculator';
// export const NUMBERS_TO_WORDS = '/Numbers-to-words';
// export const UNITS_CONVERTER = '/Units-converter';
// export const CURRENCY_CONVERTER = '/Currency-converter';
export const REPLAN = '/replan';
export const SHAPELIST = '/shapelist';
export const VCONTROL = '/vcontrol';
export const TAKEOFF = '/takeoff';
export const INVENTORY = '/inventory';
export const INVENTORY_PRODUCT_MANAGEMENT = '/inventory/product-management';
export const INVENTORY_WAREHOUSES_AND_STORAGE = '/inventory/warehouses-and-storage';
export const INVENTORY_SHIPPING_AND_RECEIVING = '/inventory/shipping-and-receiving';
export const INVENTORY_OPERATIONS = '/inventory/operations';
export const DRAGGITRM = '/inventory/resource-management';
export const INVENTORY_ALL_ENDPOINTS = '/inventory/all-endpoints';  
export const BLOG = '/blog';
export const BLOG_ARTICLE = '/blog/:slug';
export const BLOG_ADMIN = '/blog-admin';
export const PRICING = '/feature-completion-dashboard';
export const GANTT_PLANNING = '/gantt-planning';
export const PDF_STREAM_TEST = '/pdf-stream-test';
export const WAITLIST_CONFIRM = '/waitlist/confirm';
